import { callServiceMachine } from '_core/util';
import Machines from '../Machines';
import { IMessageResponse } from '_core/types';
import { MemberTypes } from '../Types';

const machine = Machines.onCreateMember.machine;

export const createMember = (
  params: MemberTypes.ICreateMemberServiceRequest,
): Promise<IMessageResponse> => {
  return callServiceMachine(machine, params);
};

export default { createMember };
